import classNames from 'classnames';
import Color from 'color';
import { Field, FieldProps } from 'formik';

import { useDarkMode } from 'hooks/browser/mediaQueries';

import { ColorPreview } from './ColorPreview';
import { PickerIcon } from './icons/PickerIcon';

interface IProps {
  name: string;
  highlightSelected?: boolean;
}

export const ColorPicker = ({ name, highlightSelected = false }: IProps) => {
  const { isDarkMode } = useDarkMode();

  return (
    <Field name={name}>
      {({ field: { value, ...field } }: FieldProps) => {
        const colors = (value || 'transparent').split(',');
        const singleValue = colors.length > 1 ? 'transparent' : colors[0];

        const isSelected = singleValue === value;
        const isDark = new Color(singleValue).isDark();

        return (
          <div className="flex">
            <div className="relative">
              <div className="absolute inset-0 z-10 overflow-hidden">
                <input
                  {...field}
                  value={singleValue.replace('transparent', '#123456')}
                  className={'absolute inset-0 appearance-none opacity-0'}
                  type="color"
                />
              </div>

              <div
                className={classNames(
                  'pointer-events-none absolute inset-0 flex items-center justify-center',
                  {
                    'text-white':
                      (singleValue !== 'transparent' && isDark) ||
                      (singleValue === 'transparent' && isDarkMode),
                    'text-mineShaftGrey':
                      (singleValue !== 'transparent' && !isDark) ||
                      (singleValue === 'transparent' && !isDarkMode),
                  },
                )}
              >
                <PickerIcon size={18} />
              </div>

              <ColorPreview
                isSelected={highlightSelected && isSelected}
                colors={[singleValue]}
              />
            </div>
          </div>
        );
      }}
    </Field>
  );
};
